var styles = {
  "Thumbnail": "Polaris-VideoThumbnail__Thumbnail",
  "ThumbnailContainer": "Polaris-VideoThumbnail__ThumbnailContainer",
  "PlayButton": "Polaris-VideoThumbnail__PlayButton",
  "Timestamp": "Polaris-VideoThumbnail__Timestamp",
  "PlayIcon": "Polaris-VideoThumbnail__PlayIcon",
  "Progress": "Polaris-VideoThumbnail__Progress",
  "Indicator": "Polaris-VideoThumbnail__Indicator",
  "ProgressBar": "Polaris-VideoThumbnail__ProgressBar",
  "Label": "Polaris-VideoThumbnail__Label"
};

export { styles as default };
